import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  CreateCommentMutation,
  CreateCommentMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { EventNames, useTracking } from "lib/tracking";
import { useGraphQlMutation } from "../useGraphQlClient";

const createComment = graphql(`
  mutation createComment($request: CreateCommentRequest!) {
    createComment(CreateCommentRequest: $request) {
      id
      content
      companyId
      objectId
      createdAt
      updatedAt
    }
  }
`);

export function useCreateComment(
  options?: UseMutationOptions<
    CreateCommentMutation,
    unknown,
    CreateCommentMutationVariables,
    unknown
  >,
) {
  const { logEvent } = useTracking();
  const { data, ...rest } = useGraphQlMutation(createComment, {
    ...options,
    onSuccess: (data, vars, context) => {
      logEvent(EventNames.commentActioned, {
        "Action type": "created",
        "Comment ID": data.createComment?.id,
      });
      options?.onSuccess?.(data, vars, context);
    },
  });

  return { data: data?.createComment, ...rest };
}
